import Hero from "@/components/ui/Hero";
import CTABlock from "@/components/ui/CTABlock";
import FAQAccordion from "@/components/ui/FAQAccordion";
import { FAQ_CATEGORIES } from "@/data/faqs";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function FAQ() {
    useDocumentTitle(
        "Pool Cage & Screen Repair FAQ · Naples, FL · A1 Screening",
        "Answers to common questions about pool cage repair, rescreening, lanai screens, screen doors, storm damage, and pricing in Naples and Southwest Florida."
    );
    return (
        <>
            <Hero
                eyebrow="FAQ"
                title="Frequently Asked Questions"
                subtitle="Real questions Naples and Southwest Florida homeowners ask us. Don't see yours? Call us or request a free estimate."
            />
            <div className="a1-container a1-section grid gap-10">
                {FAQ_CATEGORIES.map((cat) => (
                    <section key={cat.key} data-testid={`faq-cat-${cat.key}`}>
                        <h2 className="mb-3">{cat.title}</h2>
                        <FAQAccordion items={cat.items} prefix={`faq-${cat.key}`} defaultOpen={-1} />
                    </section>
                ))}
            </div>
            <CTABlock headline="Still have questions?" body="Call us or request a free estimate and we'll get back to you during business hours." />
        </>
    );
}
